import { IFaq, IMedicalDeviceInfo } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 의료기기 라벨 및 버전 조회 */
export const getMedicalDeviceInfo = async () => {
  try {
    const url = `/medicalDeviceInfo`;

    const response = await instance.get<TApiResponseData<IMedicalDeviceInfo>>(url);
    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }
    return {} as IMedicalDeviceInfo;
  } catch (error) {
    console.error(error);
  }
};

/** 자주 묻는 질문 */
export const getFaqList = async () => {
  try {
    const url = `/faq`;

    const response = await instance.get<TApiResponseData<IFaq[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
